import React from "react";
import Skeleton from 'react-loading-skeleton';
import ProfileDetailSkeleton from './user-pages/profile-detail/ProfileDetailSkeleton';

const ViewUserSkeleton = _ => {

    return (
        <>
            {/* <!--begin::Profile Overview--> */}
            <div className="d-flex flex-row">
                {/* <!--begin::Aside--> */}
                <div className="flex-row-auto offcanvas-mobile w-300px w-xl-350px" id="kt_profile_aside">
                    {/* <!--begin::Profile Card--> */}
                    <div className="card card-custom card-stretch">
                        {/* <!--begin::Body--> */}
                        <div className="card-body pt-4">
                            {/* <!--begin::User--> */}
                            <div className="d-flex align-items-center mt-5">
                                <div className="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center">
                                    <Skeleton height={100} width={100} />
                                    <i className="symbol-badge" style={{ backgroundColor: "#B5B5C3" }}></i>
                                </div>
                                <div className="w-100">
                                    <Skeleton count={3} />
                                </div>
                            </div>
                            {/* <!--end::User--> */}
                            {/* <!--begin::Contact--> */}
                            <div className="py-9">
                                <Skeleton count={6} style={{ margin: "3px 10px" }} width="40%" />
                            </div>
                            {/* <!--end::Contact--> */}
                            {/* <!--begin::Nav--> */}
                            <div className="navi navi-bold navi-hover navi-active navi-link-rounded">
                                <Skeleton count={10} width="100%" style={{ marginBottom: "10px" }} height={30} />
                            </div>
                            {/* <!--end::Nav--> */}
                        </div>
                        {/* <!--end::Body--> */}
                    </div>
                    {/* <!--end::Profile Card--> */}
                </div>
                {/* <!--end::Aside--> */}
                {/* <!--begin::Content--> */}
                <div className="flex-row-fluid ml-lg-8">
                    <ProfileDetailSkeleton />
                </div>
                {/* <!--end::Content--> */}
            </div>
            {/* <!--end::Profile Overview--> */}
        </>
    )
}

export default ViewUserSkeleton;

